import React, { useCallback, useState } from "react";
import "./AuthenticationView.css";
import styled from "styled-components";
import { LanguageSwitch } from "src/app/components/LanguageSwitch";
import NonAuthenticated from "src/app/ui/non-authenticated/NonAuthenticated";
import { AuthenticationForm } from "src/authentication/forms/AuthenticationForm";
import { OTPForm } from "src/authentication/forms/OTPForm";
import type { AuthenticationOTPContext } from "src/authentication/objects/Authentication";

export const AuthenticationView = () => {
  const [authenticationOtpContext, setAuthenticationOtpContext] = useState<
    AuthenticationOTPContext | undefined
  >(undefined);

  const handleCancelOtp = useCallback(() => {
    setAuthenticationOtpContext(undefined);
  }, []);

  return (
    <NonAuthenticated className="authentication-view">
      <LanguageSwitchStyled />
      {authenticationOtpContext ? (
        <OTPForm
          authenticationOtpContext={authenticationOtpContext}
          onCancelOtp={handleCancelOtp}
          onContextReset={setAuthenticationOtpContext}
        />
      ) : (
        <AuthenticationForm onOtpRequested={setAuthenticationOtpContext} />
      )}
    </NonAuthenticated>
  );
};

const LanguageSwitchStyled = styled(LanguageSwitch)`
  position: absolute;
  top: 15px;
  right: 15px;
`;
